<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="../../assets/loader.svg">
    </div>
</div>